import { render } from "./AposFilterMenu.vue?vue&type=template&id=28bd6356&scoped=true"
import script from "./AposFilterMenu.vue?vue&type=script&lang=js"
export * from "./AposFilterMenu.vue?vue&type=script&lang=js"

import "./AposFilterMenu.vue?vue&type=style&index=0&id=28bd6356&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bd6356"],['__file',"ui/ui/apos/components/AposFilterMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28bd6356"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28bd6356', __exports__)) {
    api.reload('28bd6356', __exports__)
  }
  
  module.hot.accept("./AposFilterMenu.vue?vue&type=template&id=28bd6356&scoped=true", () => {
    api.rerender('28bd6356', render)
  })

}


export default __exports__